/* Production */
export default "https://store-strapi.herokuapp.com";

/* Development */
// export default "http://localhost:1337";
